import { useState, useEffect } from 'react';
import { NavLink, useLocation } from 'react-router-dom';
import LogoutIcon from '@mui/icons-material/Logout';
import { USER_ROLES } from '../../constants/userRoles';
import { NAV_ITEMS_BY_ROLE } from './navConfig';
import './Sidebar.css';

function Sidebar({ drawerOpen, onClose, onLogout, userRole = USER_ROLES.PACIENTE }) {
  const navItems = NAV_ITEMS_BY_ROLE[userRole];
  const [hovered, setHovered] = useState(false);
  const location = useLocation();

  useEffect(() => {
    setHovered(false);
  }, [location.pathname]);

  return (
    <>
      <div
        className={`sidebar__backdrop ${drawerOpen ? 'sidebar__backdrop--visible' : ''}`}
        onClick={onClose}
        aria-hidden="true"
      />
      <aside
        className={`sidebar ${hovered ? 'sidebar--hovered' : ''} ${drawerOpen ? 'sidebar--drawer-open' : ''}`}
        onMouseEnter={() => setHovered(true)}
        onMouseLeave={() => setHovered(false)}
        aria-label="Menú de navegación"
      >
      <nav className="sidebar__nav">
        {navItems.map(({ Icon, label, to }) => (
          <NavLink to={to} className="sidebar__item" aria-label={label}>
            <span className="sidebar__icon"><Icon /></span>
            <span className="sidebar__label">{label}</span>
          </NavLink>
        ))}
      </nav>
      <div className="sidebar__footer">
          <button
            className="sidebar__item sidebar__item--btn sidebar__item--logout"
            onClick={onLogout}
            aria-label="Cerrar sesión"
          >
            <span className="sidebar__icon"><LogoutIcon /></span>
            <span className="sidebar__label">Cerrar sesión</span>
          </button>
      </div>
      </aside>
    </>
  );
}

export default Sidebar;
